<script>
  // packages
  import { intcomma } from 'journalize';

  // local
  import { formatPercent } from '../utils/format.js';

  /** @type {import('../types.d').CandidateInterface} */
  export let candidate;
  /** @type {import('../types.d').Crosswalk} */
  export let lookup;
  /** @type {number} */
  export let totalVotes;
  export let open = false;

  const name = `${candidate.given_name} ${candidate.family_name}`;

  function slugify(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, '-') // Replace spaces with -
      .replace(/[^\w\-]+/g, '') // Remove all non-word chars
      .replace(/\-\-+/g, '-') // Replace multiple - with single -
      .replace(/^-+/, '') // Trim - from start of text
      .replace(/-+$/, ''); // Trim - from end of text
  }
</script>

<div class="candidate-row">
  <div class="candidate-headshot {slugify(name)}">
    {#if lookup.img === 'person_male.png' || lookup.img === 'person_female.png'}
      <img src={lookup.img} alt="Headshot of {name}" width="300" height="300" />
    {:else}
      <img
        src={lookup.img}
        alt="No photo available for {name}, generic image"
        width="300"
        height="300"
      />
    {/if}
  </div>

  <dl class="candidate-info">
    <dt class="visually-hidden">Name</dt>
    <dd class="candidate-name">{name}</dd>
    <dt class="visually-hidden">Party</dt>
    <dd class="candidate-stats candidate-party">
      {candidate.party.toUpperCase()}
    </dd>
    <dt class="visually-hidden">Votes</dt>
    <dd class="candidate-stats candidate-votes">{intcomma(candidate.votes)}</dd>
    <dt class="visually-hidden">Pct.</dt>
    <dd class="candidate-stats candidate-percentage">
      {formatPercent(candidate.votes, totalVotes)}%
    </dd>
  </dl>
</div>

<details class="candidate-details" bind:open>
  <summary>
    {#if open}Hide bio{:else}Read bio{/if}
    <svg class="icon" class:icon-angle-down={!open} class:icon-angle-up={open}>
      <use xlink:href="#{open ? 'icon-angle-up' : 'icon-angle-down'}" />
    </svg>
  </summary>
  <p class="bio-occupation">Occupation: {lookup.occupation}</p>
  <p class="bio">{@html lookup.bio}</p>
</details>
